import { NgModule } from '@angular/core';

import { ProductGroupPipe } from './product.group.pipe';

@NgModule({
  declarations: [
    ProductGroupPipe
  ],
  providers: [
    ProductGroupPipe,

    // Pipes must also be provided via string
    // if they are going to be used in a table
    // column. This allows the injector to be
    // able to load a pipe dynamically in the
    // TableCellComponent.
    {
      provide : 'date',
      useClass: ProductGroupPipe
    }
  ]
})
export class ProductsModule {}